import React from 'react';
import { Form, FormControlProps } from 'react-bootstrap';
import Icon from 'components/DesignSystem/Icon';
import SubtitleRegular from 'components/Typography/SubtitleRegular';
import TextField from 'components/Typography/TextField';
import { cssVar } from 'constants/theme';
import './index.scss';

type TextFieldProps = FormControlProps & {
  as?: 'input' | 'textarea';
  label?: string;
  rows?: number;
  hint?: string;
  error?: string;
  controlId?: string;
  className?: string;
};

export default function TextFieldComponent({
  as = 'input',
  label,
  rows = 1,
  hint,
  error,
  controlId,
  className = '',
  disabled,
  ...otherProps
}: TextFieldProps) {
  const showError = error && !disabled;

  return (
    <Form.Group
      className={`ds-text-field-form ${className} ${disabled ? 'disabled' : ''}`}
      controlId={controlId}
    >
      <Form.Label className="ds-text-field-label">
        <SubtitleRegular>{label}</SubtitleRegular>
      </Form.Label>
      <Form.Control
        as={as}
        rows={rows}
        disabled={disabled}
        className={`ds-text-field-control ${hint ? 'hint' : ''}`}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...otherProps}
      />
      {showError && (
        <div className="ds-text-field-text error">
          <Icon iconType="warning" size="small" color={cssVar('danger-fg')} />
          <TextField>{error}</TextField>
        </div>
      )}
      {hint && !showError && (
        <div className="ds-text-field-text hint mt-1">
          <Icon iconType="help" size="small" />
          <TextField>{hint}</TextField>
        </div>
      )}
    </Form.Group>
  );
}
